import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=6a2289b8&"
import script from "./DocumentDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetail.vue?vue&type=style&index=0&id=6a2289b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports